import * as React from 'react';

import { createProtectedContext } from '../../lib/createProtectedContext';

type MountSettingsContextData = {
    /**
     * Ссылка на элемент в который монтируется приложение
     * @default document.body
     */
    appContainer: HTMLElement | null;

    /**
     * Позволяет задать элемент, который будет использоваться внутри приложения
     * как дефолтный для вставки тултипов, модальных окон и т.п.
     * @default appContainer
     */
    popupContainer: HTMLElement | null;
};

const mountSettingsContextDefaultValue: MountSettingsContextData =
    typeof window !== 'undefined'
        ? {
              appContainer: document.body,
              popupContainer: document.body,
          }
        : { appContainer: null, popupContainer: null };

const MountSettingsContext = createProtectedContext<MountSettingsContextData>(
    'MountSettingsContext',
    mountSettingsContextDefaultValue,
);

type MountSettingsProviderProps = React.PropsWithChildren<Partial<MountSettingsContextData>>;

function MountSettingsProvider(props: MountSettingsProviderProps) {
    return (
        <MountSettingsContext.Provider
            value={React.useMemo(() => {
                const appContainer =
                    props.appContainer ?? mountSettingsContextDefaultValue.appContainer;
                return {
                    appContainer,
                    popupContainer: props.popupContainer ?? appContainer,
                };
            }, [props.appContainer, props.popupContainer])}
            children={props.children}
        />
    );
}

const useMountSettings = MountSettingsContext.useContext;

export { MountSettingsProvider, useMountSettings };
export type { MountSettingsProviderProps };
